<div class="information-footer">
  <div
    [ngStyle]="isBigInformationFooter ? {display: 'flex', 'flex-direction': 'column-reverse'} : {}"
    class="container-boxed"
  >
    <p
      [ngClass]="{
        'information-footer--description__margin--bottom': !isBigInformationFooter,
        'information-footer--description__margin--top': isBigInformationFooter,
      }"
      class="information-footer--description"
      [innerHTML]="'informationFooter.informationMessage2' | translate"
    ></p>
    @if (isBigInformationFooter) {
      <p
        class="information-footer--description"
        [innerHTML]="'informationFooter.informationMessage1' | translate"
      ></p>
    }

    <div class="information-footer--payment--container">
      <div class="information-footer--pdf--container">
        @if (isBigInformationFooter) {
          <img
            class="information-footer--pdf--icon"
            [src]="'informationFooter.iconPDF' | translate"
            alt="icona pdf"
          />
          <nx-link nxStyle="block">
            <a
              class="information-footer--pdf--link"
              target="_blank"
              [href]="
                ('common.baseUrls.informationPdf' | translate) +
                dossier?.FileName
              "
              rel="noopener"
              (click)="onClick($event)"
              (mouseenter)="onHover()"
              (focus)="onHover()"
              >{{ 'informationFooter.informationPDF' | translate }}</a
            >
          </nx-link>
        }
      </div>
      <span
        [ngClass]="{'information-footer--payment--text__bigFooter': isBigInformationFooter}"
        class="information-footer--payment--text"
        >{{ 'informationFooter.payment.label' | translate }}</span
      >
      <div class="information-footer--payment--icon--wrapper">
        @for (iconName of iconsNameContent; track iconName) {
          <span
            [ngStyle]="{
              background:
                'url(' +
                ('informationFooter.payment.' + iconName + '.icon' | translate) +
                ') center no-repeat',
            }"
            class="information-footer--payment--icon"
            >{{ 'informationFooter.payment.' + iconName + '.label' | translate }}</span
          >
        }
      </div>
    </div>
  </div>
</div>
